import type { SubjectAreaCode } from '@dosfilos/domain';

// Area → accent. Distinct hues; ELECTIVES stays neutral. Kept in sync with the
// eight SubjectAreaCode values. Lives outside any component so the malla view,
// the ladder view and the ladder PDF (which also renders in Node) share it.
export const AREA_COLOR: Record<SubjectAreaCode, string> = {
  OT_SURVEY: '#0EA5E9',
  NT_SURVEY: '#6366F1',
  HERMENEUTICS: '#8B5CF6',
  THEOLOGY: '#EC4899',
  TEXTUAL_EXEGESIS: '#14B8A6',
  EXPOSITORY_PREACHING: '#F59E0B',
  PASTORAL_MINISTRIES: '#10B981',
  ELECTIVES: '#64748B',
};

/** A course with no CCD yet has no area. */
export const NO_AREA_COLOR = '#94A3B8';
